// Laravel serialise les colonnes decimal en JSON comme des strings (ex: "115000.00")
// au lieu de nombres. Sans cette conversion, `sum + raw.total` fait de la concatenation
// de strings au lieu d'une addition (ex: 3 commandes -> "0115000.00110000.0095000.00").
export function toNumber(value: unknown): number {
  if (typeof value === 'number') return value;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}
